import { render, staticRenderFns } from "./OffersPage.vue?vue&type=template&id=47079459&"
import script from "./OffersPage.vue?vue&type=script&lang=js&"
export * from "./OffersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports